import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { EmployeeProblemPopup } from './EmployeeProblemTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import moment from 'moment';
import CommonServices from '../../../services/axiosServices/apiServices/CommonServices';
import { saveAs } from "file-saver";
import { permission } from '../../../utils/enums/ValidationMessage';

export default class EmployeeProblem extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.commonServices = new CommonServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            entryBy: "",
            employeeObject: {
                idEmployeeProblem: 0,
                updateStatus: 0,
                date: '',
                idEmployee: 0,
                employeeList: [],
                problemDesc: '',
                attachment: '',
                fileExtension: "",
                e_Date: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],

            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.resetFields();
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        }, () => {
            this.usp_Extra_EmployeeProblemSelectById(event.data.idEmployeeProblem);
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.employeeObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.employeeObject;
        if (name === "assembly") {
            details.assembly = !details.assembly
        } else {
            details[name] = value;
        }
        this.setState({ employeeObject: details });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    }


    handleChangeForDropdown = (event, name) => {
        let details = this.state.employeeObject;
        let value = event.value;
        details[name] = value;
        this.setState({ employeeObject: details });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.personName ? prop.personName : "" }, () => {
                this.procSelectAllRecordsSP();
                //this.getPrefixSelectPrefix();
                this.getAllDropdownAndCountsForOtherForms();
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Employee Problem",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idEmployeeProblem"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Employee Problem",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            //this.procSelectAllRecord2GridviewSP(id);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.04,
            "date": window.innerWidth * 0.04,
            "entryTime": window.innerWidth * 0.06,
            "employeeName": window.innerWidth * 0.20,
            "problemDescription": window.innerWidth * 0.09,
            "isComplete": window.innerWidth * 0.06,
            "completeDate": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    getAllDropdownAndCountsForOtherForms = () => {
        let request = [this.state.idCompany, 0];
        this.otherFormsServices.getAllDropdownAndCountsForOtherForms(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.employeeObject;
                ///let dAssNo = allData.filter(item => item.source === 'StockTransfer')?.[0].value;
                let employeeList = allData.filter(item => item.source === 'Extra_User');
                // let maxIdPaymentMake = dAssNo > 0 ? dAssNo : 0;
                // let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                // data.transferNo = data.prefix + receiptNo;
                data.employeeList = employeeList;
                this.setState({
                    employeeObject: data
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    usp_Extra_EmployeeProblemSelectById = (id) => {
        if (id > 0) {
            this.otherFormsServices.usp_Extra_EmployeeProblemSelectById(id).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent[0];
                    let obj = this.state.employeeObject;
                    obj.idEmployeeProblem = dynamicData.idEmployeeProblem;
                    obj.updateStatus = 1;
                    obj.date = moment(dynamicData.date).format('YYYY-MM-DD');
                    obj.idEmployee = dynamicData.employee;
                    obj.problemDesc = dynamicData.problemDescription;
                    obj.attachment = dynamicData.fileName;

                    this.setState({
                        employeeObject: obj,
                        isModalOpen: true
                    }, () => {
                    });
                }
            })
        }
    }

    submit = () => {
        //const isValidAllFields = this.isValidAllFields();
        //if (isValidAllFields) {
        // if (this.state.itemRowData.length === 0) {
        //     this.SwalServices.Alert("Please add items details");
        // } else {
        let data = this.state.employeeObject
        let request = {
            idEmployeeProblem: data.idEmployeeProblem,
            updateStatus: data.updateStatus,
            date: data.date,
            employee: data.idEmployee,
            fileName: data.attachment,
            fileExtension: data.fileExtension,
            problemDescription: data.problemDesc,
            idCompany: this.state.idCompany,
            e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
            entryBy: this.state.entryBy ? this.state.entryBy : "",
            idUser: this.state.idUser,
            isUpdated: data.updateStatus === 1 ? true : false,
            u_Date: data.updateStatus === 1 ? new Date().toISOString() : null,
            u_By: this.state.entryBy ? this.state.entryBy : "",
        };
        this.otherFormsServices.usp_Extra_EmployeeProblemInsertUpdate(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data !== null) {
                    if (this.state.employeeObject.updateStatus === 1) {
                        this.SwalServices.Success("Updated sucessfully.");
                    } else {
                        this.SwalServices.Success("Save sucessfully.");
                    }
                    if (this.state.urlId) {
                        this.setState({ route: '/ledger-report' });
                    } else {
                        this.setState({
                            isModalOpen: false,
                            //receiptDetails: reset
                        }, () => {
                            this.resetFields();
                            this.procSelectAllRecordsSP();
                        });
                    }
                }
            }
        });
        //}
        //}
    }

    resetFields = () => {
        let obj = this.state.employeeObject;
        obj.idEmployeeProblem = 0;
        obj.updateStatus = 0;
        obj.date = '';
        obj.idEmployee = 0;
        //obj.employeeList = [];
        obj.problemDesc = '';
        obj.attachment = '';
        obj.fileExtension = "";
        obj.e_Date = "";
        this.setState({ employeeObject: obj })
    }

    onFileChange = (event, identity) => {
        //debugger
        const file = event.target.files[0];
        // if (identity === "Upload_Certificate") {
        if (
            file &&
            (file.type === "image/jpeg" ||
                file.type === "image/png" ||
                file.type === "application/pdf" ||
                file.type === "application/pdf" ||
                file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel" ||
                file.type === "application/vnd.ms-excel")
        ) {
            let uploadFile = { ...this.state.resFile };
            uploadFile.filename = file.name;
            uploadFile["file"] = file;
            uploadFile.storagePath = identity;
            this.commonServices.uploadPDF(uploadFile).then((response) => {
                if (response != null) {
                    let detail = this.state.employeeObject;
                    if (identity === 'EmployeeProblemAttachment') {
                        detail.attachment = response.fileName;
                    }
                    this.setState({ employeeObject: detail });
                    this.SwalServices.Success("Uploaded");
                }
                else {
                    this.SwalServices.Error(response.message);
                }
            })
        }
        else {
            this.SwalServices.Error("Please select only Image!");
        }
        // }      
    };

    getFiles = (type, Filepath) => {
        if (Filepath) {
            let request = [
                type,
                Filepath,
            ];
            this.commonServices.getFiles(request).then((response) => {
                if (response.data !== null && response.status === 200) {
                    var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
                    var filename = "";
                    filename = `${type}${formattedDate}`;
                    const extension = Filepath.split(".").pop();
                    if (extension) {
                        saveAs(new Blob([response.data]), `${filename}.${extension}`);
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("No data found");
        }
    };


    render() {
        return (
            <div className='manual-invoice'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                //add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <EmployeeProblemPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            employeeObject={this.state.employeeObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            onFileChange={this.onFileChange.bind(this)}
                            getFiles={this.getFiles.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Employee problem</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
